export default `query GetReportData($from: String!, $to: String!, $profile: String, $offset: Int) {
  getReportData(from: $from, to: $to, profile: $profile, offset: $offset) {
    articles {
      item_id
      title
      id
      current_status
      fecha
      auditor
      seller_name
      seller_id
      motivo
    }
  }
}`;
